import { render, staticRenderFns } from "./PayExpenses.vue?vue&type=template&id=65cfb242&scoped=true"
import script from "./PayExpenses.vue?vue&type=script&lang=js"
export * from "./PayExpenses.vue?vue&type=script&lang=js"
import style0 from "./PayExpenses.vue?vue&type=style&index=0&id=65cfb242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cfb242",
  null
  
)

export default component.exports